import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/trackingStepperStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Button from 'components/CustomButtons/Button';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import ErrorBox from 'components/ErrorBox/ErrorBox';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { finalize } from 'rxjs/operators';
import { IGetOrderTrackingResponse, OrderTrackingService } from 'services/orderTracking/orderTracking';
import TrackingStepper from './TrackingStepper';
// @ts-ignore
const useStyles = makeStyles(styles);

interface IOrderTracking {
	orderId: string;
}

const OrderTracking: FunctionComponent<IOrderTracking> = ({ orderId }) => {
	const [orderTracking, setOrderTracking] = useState<IGetOrderTrackingResponse[]>();
	const [loading, setLoading] = useState(false);
	const classes = useStyles();

	useEffect(() => {
		setLoading(true);
		OrderTrackingService.getOrderTracking({ orderId })
			.pipe(finalize(() => setLoading(false)))
			.subscribe((response) => {
				if (!!response?.length) {
					setOrderTracking(response);
				}
			});
	}, []);

	return (
		<ConditionalRender
			show={loading}
			onTrue={() => <CustomCircularProgress loading={loading} text={translate('loading')} />}
			onFalse={() => (
				<div className={classes.orderTracking}>
					<ConditionalRender
						show={!!orderTracking && !!orderTracking[0]}
						onTrue={() => (
							<>
								<TrackingStepper orderTracking={orderTracking![0]} />
								<ConditionalRender
									show={
										!!orderTracking &&
										!!orderTracking[0] &&
										!orderTracking[0].tracking.some((t) => t.status === 'READY_TO_PICKUP')
									}
									onTrue={() => (
										<TrackingLink
											shippingId={orderTracking![0].trackingNumber}
											trackingUrl={orderTracking![0].trackingUrl}
										/>
									)}
								/>
							</>
						)}
						onFalse={() => <ErrorBox text={translate('something.went.wrong')} />}
					/>
				</div>
			)}
		/>
	);
};

const TrackingLink = ({ shippingId, trackingUrl }: { shippingId: string; trackingUrl: string }) => {
	const classes = useStyles(styles);
	return (
		<div className={classes.trackingLink}>
			<BodyS>{translate('tracking.track.shipping.id', shippingId)}</BodyS>
			<a href={trackingUrl}>
				<Button color={'tertiary-light'}>{translate('tracking.track.delivery')}</Button>
			</a>
		</div>
	);
};

export default OrderTracking;
